import{
    ADD_UPDATE_ECOLAB_ITEMDETAILS_FAILURE,
    ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST,
    ADD_UPDATE_ECOLAB_ITEMDETAILS_SUCCESS,  
    FETCH_ECOLAB_ITEMDETAILS_LIST_FAILURE,
    FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST,
    FETCH_ECOLAB_ITEMDETAILS_LIST_SUCCESS
} from "./actionTypes";
import { EcolabItemDetails } from "./types";

export const fetchEcolabItemDetailsListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  }
) => ({
  type: FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST,
  url,
  payload,
});

export const fetchEcolabItemDetailsListSuccess = (
  ecolabItemDetailsList: EcolabItemDetails[],
  totalCount: number
) => ({
  type: FETCH_ECOLAB_ITEMDETAILS_LIST_SUCCESS,
  payload: { ecolabItemDetailsList, totalCount },
});

export const fetchEcolabItemDetailsListFailure = (error: string) => ({
  type: FETCH_ECOLAB_ITEMDETAILS_LIST_FAILURE,
  payload: error,
});

export const addUpdateEcolabItemDetailsRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateEcolabItemDetailsSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_ECOLAB_ITEMDETAILS_SUCCESS,
  payload: { successMessage },
});

export const addUpdateEcolabItemDetailsFailure = (error: string) => ({
  type: ADD_UPDATE_ECOLAB_ITEMDETAILS_FAILURE,
  payload: error,
});
